<template>
  <div style="width: 100%; height: 100%">
    <el-card
      style="width: 100%; height: 100%; overflow: hidden"
      v-loading="loading"
    >
      <div style="width: 50%; min-width: 400px; margin: 0 auto; display: flex">
        <div style="width: 30%">
          <el-card
            style="height: 120px"
            :body-style="{
              display: 'flex',
              alignItems: 'center',
            }"
          >
            <el-avatar
              :size="80"
              fit="contain"
              :src="SupplierInfo.UserAvatarURL"
              icon="el-icon-user-solid"
            ></el-avatar>

            <div
              style="
                text-align: center;
                width: calc(100% - 100px);
                font-weight: bold;
                margin-left: 20px;
                font-size: 20px;
              "
            >
              <div class="ellipsis2" :title="SupplierInfo.cVenPerson">
                {{ SupplierInfo.cVenPerson }}
              </div>
            </div>
          </el-card>
          <el-card v-if="TrueOrFalse == 1">
            <el-button style="width: 100%" type="primary" @click="handleBack"
              >返回主页</el-button
            >
          </el-card>
        </div>
        <el-card style="width: 65%; margin-left: 5%">
          <div
            style="height: calc(540px); overflow-y: auto; position: relative"
          >
            <div
              style="
                font-size: 20px;
                font-weight: bold;
                margin-bottom: 10px;
                position: sticky;
                top: 0;
                left: 0;
                background-color: #fff;
                z-index: 10;
              "
            >
              账户信息
            </div>
            <el-form
              ref="form"
              :model="SupplierInfo"
              :rules="SupplierInfoRules"
              label-width="130px"
              label-position="left"
              style="width: 80%; position: relative"
            >
              <!-- <div style="position: absolute; right: 10px; top: 10px">
                <el-tag v-if="SupplierInfo.Status == 1" type="warning" size="medium"
                  >待审核
                </el-tag>
                <el-tag
                  v-if="SupplierInfo.Status == 2 || SupplierInfo.Status == 3"
                  type="success"
                  size="medium"
                  >已审核
                </el-tag>
                <el-tag v-if="SupplierInfo.Status == 4" type="danger" size="medium"
                  >驳回
                </el-tag>
              </div> -->
              <!-- <el-form-item label="头像" prop="UserAvatarURL">
                <el-upload
                  class="avatar-uploader"
                  :action="
                    $rootUrl +
                    `/Base_Manage/Upload/ProjectOssUploadFileByForm?ProjectId=${SupplierInfo.ProjectId}&UserId=${SupplierInfo.Id}&Type=1&SupplierId=${SupplierInfo.Id}`
                  "
                  :headers="{
                    Authorization: token,
                  }"
                  :show-file-list="false"
                  :on-success="
                    (res, file) => handleAvatarSuccess(res, file, 'UserAvatarURL')
                  "
                  :before-upload="beforeAvatarUploadImg"
                >
                  <div
                    style="width: 120px; height: 120px; display: flex"
                    v-if="SupplierInfo.UserAvatarURL"
                  >
                    <div style="width: 120px; height: 120px">
                      <el-image
                        fit="cover"
                        :src="SupplierInfo.UserAvatarURL"
                        style="width: 100%; height: 100%"
                      ></el-image>
                    </div>
                  </div>
                  <div
                    v-if="!SupplierInfo.UserAvatarURL"
                    style="
                      width: 120px;
                      height: 120px;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                    "
                  >
                    <i class="el-icon-plus" style="font-size: 40px; color: #ccc"></i>
                  </div>
                </el-upload>
              </el-form-item> -->
              <!-- <el-form-item label="" v-if="SupplierInfo.Status == 4">
                <span style="color: red"
                  >驳回原因 ： {{ SupplierInfo.RejectReason }}</span
                >
              </el-form-item> -->

              <el-form-item label="供应商名称" prop="cVenName">
                <el-input v-model="SupplierInfo.cVenName"></el-input>
              </el-form-item>
              <el-form-item label="联系人" prop="cVenPerson">
                <el-input v-model="SupplierInfo.cVenPerson"></el-input>
              </el-form-item>
              <el-form-item label="联系人电话" prop="cVenPhone">
                <el-input
                  v-model="SupplierInfo.cVenPhone"
                  :maxlength="11"
                  type="text"
                  show-word-limit
                ></el-input>
              </el-form-item>
              <!-- <el-form-item label="税号" prop="TaxId">
                <el-input v-model="SupplierInfo.TaxId" type="number"></el-input>
              </el-form-item> -->
              <!-- <div
                v-for="item in SupplierInfo.project_DictionaryDetails"
                :key="item.DicValue"
              >
                <el-form-item :label="item.DicName" :prop="item.DicValue">
                  <el-upload
                    :limit="9"
                    :disabled="SupplierInfo.Status == 2 || SupplierInfo.Status == 3"
                    :auto-upload="true"
                    :ref="'upload_' + item.DicValue"
                    :action="
                      $rootUrl +
                      `/Base_Manage/Upload/ProjectOssUploadFileByForm?ProjectId=${SupplierInfo.ProjectId}&UserId=${SupplierInfo.Id}&Type=1`
                    "
                    :headers="{
                      Authorization: token,
                    }"
                    :on-error="
                      (err, file, fileList) => handleError(err, file, fileList, scope.row)
                    "
                    accept="image/*, .pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx"
                    :on-exceed="handleExceed"
                    :on-preview="handlePreview"
                    :show-file-list="true"
                    :file-list="DocumentListUpload[item.DicValue]"
                    :before-remove="(file) => beforeRemove(file, item)"
                    :on-change="
                      (file, fileList) => handleChange(file, fileList, item.DicValue)
                    "
                    :on-remove="(file, fileList) => handleRemove(file, fileList, item)"
                    :on-success="(res, file) => handleSuccess(res, file, item)"
                    :before-upload="
                      (file, fileList) => beforeUpload(item, file, fileList)
                    "
                  >
                    <el-button
                      size="mini"
                      type="primary"
                      :disabled="SupplierInfo.Status == 2 || SupplierInfo.Status == 3"
                      >{{ "选择文件" }}</el-button
                    >
                   
                  </el-upload>
                </el-form-item>
              </div> -->

              <el-form-item
                label=""
                style="
                  position: sticky;
                  bottom: 0;
                  background-color: #fff;
                  z-index: 10;
                "
              >
                <el-button
                  style="width: 100%"
                  type="primary"
                  @click="handleSave"
                  >保存</el-button
                >
              </el-form-item>
            </el-form>
          </div>
        </el-card>
      </div>
    </el-card>
  </div>
</template>
<script>
// import folder from "@/assets/folder-old.png";
import Token from '@/utils/cache/TokenCache.js'
import TokenCache from '@/utils/cache/TokenCache'
export default {
  data() {
    return {
      loading: false,
      TrueOrFalse: 0,
      // folder,
      SupplierInfo: {
        BusinessLicenseUrl: '',
        base_ProjectSupplierTypeFilesList: [],
      },
      SupplierInfoCopy: {},
      DocumentList: [],
      DocumentListUpload: {},
      token: '',
      SupplierInfoRules: {
        cVenPerson: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
        ],
        cVenPhone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
        ],
        cVenName: [
          { required: true, message: '请输入供应商名称', trigger: 'blur' },
        ],
        TaxId: [{ required: true, message: '请输入税号', trigger: 'blur' }],
        // BusinessLicenseUrl: [
        //   { required: true, message: "请上传营业执照", trigger: "blur" },
        // ],
        // SafetyProductionLicense: [
        //   { required: true, message: "请上传安全生产许可证", trigger: "blur" },
        // ],
      },
    }
  },
  props: {},
  components: {},
  methods: {
    handleError() {
      this.loading = false
      this.$notify.error('上传失败')
    },
    beforeUpload(item, file) {
      const isImage = file.type.startsWith('image/')
      const allowedDocumentExtensions = [
        'pdf',
        'doc',
        'docx',
        'xls',
        'xlsx',
        'ppt',
        'pptx',
      ]
      const fileExtension = file.name.split('.').pop().toLowerCase()

      // 验证是否为图片或文档
      if (!isImage && !allowedDocumentExtensions.includes(fileExtension)) {
        this.$notify.error('只能上传图片或文档文件！')
        return false
      } else {
        this.loading = true
        return true
      }
    },
    async handleRemove(file, fileList, row) {
      if (file.Id) {
        this.$http
          .post('/Base_ProjectWork/Base_ProjectSupplierTypeFiles/DeleteData', [
            file.Id,
          ])
          .then((res) => {
            if (res.Success) {
              this.SupplierInfo.base_ProjectSupplierTypeFilesList =
                this.SupplierInfo.base_ProjectSupplierTypeFilesList.filter(
                  (val) => {
                    return val.Id != file.Id
                  }
                )
              window.localStorage.setItem(
                'base_Supplier',
                JSON.stringify(this.SupplierInfo)
              )
              this.$notify.success('删除成功')
            }
          })
        return
      }
      // this.fileInfo[row.Type + "List"] = fileList;
      // // console.log(this.form[item.FiledKey + "fileList"], "fileList");
      let index = this.DocumentListUpload[row.DicValue].findIndex((val) => {
        return val.uid === file.uid
      })
      if (index > -1) {
        this.DocumentListUpload[row.DicValue].splice(index, 1)
      }
    },
    getDocumentList() {
      this.$http
        .post('/Base_ProjectManage/Project_DictionaryMain/GetTheDataByDicKey', {
          Condition: 'DicKey',
          Keyword: 'SupplierType',
        })
        .then((res) => {
          if (res.Success) {
            this.DocumentList = res.Data.DictionaryDetailsList
            this.SupplierInfo.base_ProjectSupplierTypeFilesList.forEach(
              (item) => {
                this.$set(
                  item,
                  'name',
                  item.OriginalFileName || item.NewFileName
                )
                this.$set(item, 'size', item.Size)
                this.$set(item, 'url', item.Url)
                this.$set(item, 'status', item.Id ? 'success' : '')
              }
            )
            // if (this.SupplierInfo.base_ProjectSupplierTypeFilesList.length > 0) {
            //   this.$set(this.SupplierInfo, "base_ProjectSupplierTypeFilesListCopy", [
            //     ...this.SupplierInfo.base_ProjectSupplierTypeFilesList,
            //   ]);
            // }
            this.DocumentList.forEach((item) => {
              let arr =
                this.SupplierInfo.base_ProjectSupplierTypeFilesList.filter(
                  (val) => {
                    return val.Type == item.DicValue
                  }
                )

              this.$set(this.DocumentListUpload, item.DicValue, [...arr])
            })
            // this.SupplierInfo.DocumentJons = {};
            // this.$set(this.SupplierInfo, "base_ProjectSupplierTypeFilesList", []);

            // this.DocumentList.forEach((item) => {
            //   this.$set(this.SupplierInfo.DocumentJons, item.DicValue, {

            //   });
            // });
          }
        })
    },
    getUrlType(url) {
      let suffixName = url.split('.').pop()
      if (/(jpg|jpeg|png|GIF|JPG|PNG)$/.test(suffixName)) {
        return true
      } else {
        return false
      }
    },

    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 20

      if (!isLt2M) {
        this.$notify.error('上传文件大小不能超过 20MB!')
      }
      return isLt2M
    },
    beforeAvatarUploadImg(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 20

      if (!isJPG) {
        this.$notify.error('上传图片只能是 JPG 或 PNG 格式!')
      }
      if (!isLt2M) {
        this.$notify.error('上传头像图片大小不能超过 20MB!')
      }
      return isJPG && isLt2M
    },
    handlePreview(file) {
      window.open(file.url || file.response.Url || file.response.url)
    },
    handleExceed(files, fileList) {
      this.$notify.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      )
    },
    handleChange(file, fileList, Type) {
      // this.form[item.FiledKey + "fileList"] = [...fileList];
      this.DocumentListUpload[Type] = [...fileList]
      // console.log(file, fileList, item, "文件改变状态");
    },
    beforeRemove(file, item) {
      const isImage = file.raw.type.startsWith('image/')
      const allowedDocumentExtensions = [
        'pdf',
        'doc',
        'docx',
        'xls',
        'xlsx',
        'ppt',
        'pptx',
      ]
      const fileExtension = file.name.split('.').pop().toLowerCase()
      if (!isImage && !allowedDocumentExtensions.includes(fileExtension)) {
        return true
      }
      return new Promise((response, reject) => {
        this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            return response()
          })
          .catch(() => {
            return reject()
          })
      })
    },
    handleSuccess(res, file, item) {
      if (res.code == 200) {
        this.loading = false
        // this.$set(this.SupplierInfo.DocumentList[item], "url", res.url);
        // this.DocumentListUpload[item.DicValue]

        this.SupplierInfo.base_ProjectSupplierTypeFilesList = [
          ...this.SupplierInfo.base_ProjectSupplierTypeFilesList,
          {
            ProjectId: this.SupplierInfo.ProjectId,
            SupplierId: this.SupplierInfo.Id,
            Type: item.DicValue,
            TypeName: item.DicName,
            Url: res.url,
            NewFileName: file.name,
            OriginalFileName: file.name,
            Size: file.size,
            name: file.name,
            size: file.size,
            uid: file.uid,
            url: file.response.url,
            status: file.status,
          },
        ]
        // let allSuccess = this.DocumentListUpload[item.DicValue].every((val) => {
        //   return val.status == "success";
        // });
        // if (allSuccess) {
        //   this.SupplierInfo.base_ProjectSupplierTypeFilesList = [
        //     ...this.SupplierInfo.base_ProjectSupplierTypeFilesList,
        //     ...this.DocumentListUpload[item.DicValue],
        //   ];
        // }

        //；立即上传注释掉
        // let flag = this.SupplierInfo.base_ProjectSupplierTypeFilesList.every((item) => {
        //   return item.status == "success";
        // });

        // if (flag) {
        //   this.handleSave();
        // }
        // console.log(flag, "是否全部列表都上传完毕");
      } else {
        this.loading = false
        this.$notify.error(res.Msg)
      }
    },
    handleAvatarSuccess(res, file, item) {
      if (res.code == 200) {
        // this.SupplierInfo[item] = res.url;
        this.$set(this.SupplierInfo, item, res.url)
        // this.$set(this.SupplierInfo, item, res.url);
        // console.log(this.SupplierInfo);
        // this.$http
        //   .post("/Base_ProjectWork/Base_Project/SaveData", this.entity)
        //   .then((res) => {
        //     this.loading = false;
        //     if (res.Success) {
        //       this.$notify.success("操作成功");
        //     } else {
        //       this.entity.ProjectImg = "";
        //       this.$notify.error(res.Msg);
        //     }
        //   });
      } else {
        this.$notify.error(res.Msg)
      }
    },
    handleBack() {
      this.$router.push('/TemplateHome')
    },
    handleSave() {
      const reg = /^1[345789]\d{9}$/ // 手机号正则
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return
        }
        if (!this.SupplierInfo.cVenPhone) {
          return this.$notify.error('请输入正确的手机号')
        }
        // 验证手机号格式
        if (
          this.SupplierInfo.cVenPhone &&
          !reg.test(this.SupplierInfo.cVenPhone)
        ) {
          this.$notify.error('请核对手机号格式')
          return
        }

        // //验证是否全部上传完毕
        // let flag = this.DocumentList.every((item) => {
        //   return this.DocumentListUpload[item.DicValue].every((val) => {
        //     return val.status == 'success'
        //   })
        // })

        // if (!flag) {
        //   this.DocumentList.forEach((item) => {
        //     this.$refs['upload_' + item.DicValue][0].submit()
        //   })
        //   return
        // }
        this.$confirm('确认保存当前用户信息吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          this.loading = true
          this.$http
            .post(
              '/Base_BasicData/Base_Supplier/UpdateSupplier',
              this.SupplierInfo
            )
            .then(async (res) => {
              this.loading = false
              if (res.Success) {
                if (
                  this.SupplierInfo.cVenPhone !==
                  this.SupplierInfoCopy.cVenPhone
                ) {
                  this.$notify.success('检测到已更换手机号，请重新登录')

                  TokenCache.deleteToken()
                  this.$store.state.userInfo = {}
                  await this.$store.dispatch('setUser', false)
                  // this.$store.state.isLogin = false;
                  let ProjectId = window.localStorage.getItem('exeProjectId')
                  this.$router.replace('/TemplateLogin?ProjectId=' + ProjectId)
                  return
                }
                this.$notify.success('保存成功,正在跳转中....')
                window.localStorage.setItem(
                  'base_Supplier',
                  JSON.stringify(res.Data)
                )
                this.TrueOrFalse = 1
                window.localStorage.setItem('TrueOrFalse', 1)
                setTimeout(() => {
                  this.$router.push('/TemplateHome')
                }, 1)
              } else {
                this.$notify.error(res.Msg)
              }
            })
        })
      })
    },
    async getUserInfo() {
      this.loading = true
      await this.$http
        .post(
          `/Base_BasicData/Base_SupplierToken/GetSupplierDTOData?projectId=${this.SupplierInfo.ProjectId}&supplierId=${this.SupplierInfo.Id}`,
          {}
        )
        .then((res) => {
          this.loading = false
          if (res.Success) {
            this.SupplierInfo = res.Data
            this.SupplierInfoCopy = JSON.parse(
              JSON.stringify(this.SupplierInfo)
            )
            window.localStorage.setItem(
              'base_Supplier',
              JSON.stringify(res.Data)
            )
          }
        })
    },
  },
  mounted() {},
  async created() {
    this.token = 'Bearer ' + Token.getToken()
    this.SupplierInfo = window.localStorage.getItem('base_Supplier')
      ? JSON.parse(window.localStorage.getItem('base_Supplier'))
      : {}
    this.SupplierInfoCopy = JSON.parse(JSON.stringify(this.SupplierInfo))
    this.TrueOrFalse = window.localStorage.getItem('TrueOrFalse')
    await this.getUserInfo()
    this.getDocumentList()
  },
  computed: {},
  watch: {},
}
</script>
<style lang="scss" scoped>
::v-deep .el-form-item__label {
  font-weight: bold;
  font-size: 14px;
}
</style>
